import React from 'react'

import { AdminContext } from 'contexts/AdminContext'

import { AsyncSelect, Form, Col, Button } from '_zari/core'

import { NuevoProveedorModal } from 'sharedComponents/modals'

import TipoDeBusquedaSociosConstant from 'constants/tiposDeBusquedaDeSocios'

import * as SocioCrud from 'services/socio.service'

const SocioFormGroup = ({ fIsSubmitting, iValue, values, setValues }) => {
  const __adminContext = React.useContext(AdminContext)

  const [mostrarNuevoSocioModal, setMostrarNuevoSocioModal] = React.useState(false)

  const loadSociosSelect = (inputValue, resolve) => {
    SocioCrud.obtenerProveedoresxBusquedaAsSelect2({
      busqueda: inputValue,
      tipoSalida: 'codigo-ruc'
    }).then(({ data }) => resolve(data))
  }

  const onChangeSocioHandler = pickedMember => {
    SocioCrud.obtenerxIdAsInfoSlim(pickedMember.value).then(({ data }) => {
      values._idSocio = pickedMember.value
      values.codigoSocio = data.codigo
      values.documentoSocio = data.numeroDocumento
      values.tipoDocumentoSocio = data.tipoDocumento
      values.nombreSocio = data.razonSocial

      setValues(values)
    })
  }

  const clickMostrarNuevoSocioModalHandler = e => {
    e.preventDefault()
    setMostrarNuevoSocioModal(true)
  }

  const seleccionarSocioCreadoHandler = socioCreado => {
    setMostrarNuevoSocioModal(false)
    values._idSocio = socioCreado._id
    values.nombreSocio = socioCreado.razonSocial
    values.codigoSocio = socioCreado.codigo
    values.documentoSocio = socioCreado.numeroDocumento
    values.tipoDocumentoSocio = socioCreado.tipoDocumento

    setValues(values)
  }

  return (
    <>
      <Form.Group>
        <Form.Label
          text={
            TipoDeBusquedaSociosConstant.__dictionary[
              __adminContext.valoresConfiguracionCompania.tipoBusquedaSocios
            ].nombre
          }
          htmlFor='input-codigoRucSocio'
          md={2}
        />
        <Col md={10}>
          {values._idSocio ? (
            <Form.InputText
              disabled
              id='input-codigoRucSocio'
              defaultValue={
                __adminContext.valoresConfiguracionCompania.tipoBusquedaSocios ===
                TipoDeBusquedaSociosConstant.CODIGO
                  ? values.codigoSocio
                  : values.documentoSocio
              }
            />
          ) : (
            <Form.InputGroup>
              <AsyncSelect
                selectId='codigoRucSelect'
                loadOptions={loadSociosSelect}
                onChange={onChangeSocioHandler}
              />
              <Form.InputGroup.Append>
                <Button disabled={fIsSubmitting} onClick={clickMostrarNuevoSocioModalHandler}>
                  &#x2b;
                </Button>
              </Form.InputGroup.Append>
            </Form.InputGroup>
          )}
        </Col>
      </Form.Group>
      {mostrarNuevoSocioModal && (
        <NuevoProveedorModal
          handleClose={e => setMostrarNuevoSocioModal(false)}
          show={mostrarNuevoSocioModal}
          onCreate={seleccionarSocioCreadoHandler}
        />
      )}
    </>
  )
}

export default React.memo(SocioFormGroup)
